// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SportTicketSistema_wrapper__R1syV","list":"SportTicketSistema_list__RHQCK"};